<template>
  <div>
    <!-- signUp teacher Section -->
    <section class="signUp">
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="2">
            <v-card
              class="mx-auto"
              max-width="300"
              outlined
              elevation="1"
              style="margin-top: 70px"
            >
              <v-img
                :src="
                  info.img != ''
                    ? info.img
                    : info.gender == 'm'
                    ? defaultAvaterMale
                    : defaultAvaterfeMale
                "
                height="200px"
              ></v-img>
              <v-card-title class="text-center second-color">
                {{ info.name }}
              </v-card-title>
              <v-card-text>
                <p class="main-color">
                  <v-icon color="#ffc382">book</v-icon>
                  <!-- <v-icon>langauge</v-icon> -->
                  <strong>{{ $t("subject") }}:</strong>
                  <span>{{ info.subject }}</span>
                </p>

                <p class="main-color">
                  <v-icon color="#ffc382">subject</v-icon>
                  <strong>{{ $t("curriculum") }}:</strong>
                  <span>{{ info.curriculum }}</span>
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="10">
            <h2 class="main-color text-center">مادة {{ info.subject }}</h2>
            <p class="text-center" v-if="!sessionEnded">
              {{ $t("The session will end automatically at") }}
              {{ end_time_12_hrs }}
              {{ end_time_12_hrs_prefix }}
            </p>
            <p v-else class="text-center">
              {{ $t("sessionEnd") }}
              <!-- {{ end_time_12_hrs }} {{ end_time_12_hrs_prefix }} -->
            </p>
            <iframe
              width="100%"
              height="500"
              :src="zoomUrl"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              @load="redirectAfterSession"
              ref="iFrame"
              v-if="!sessionEnded"
            ></iframe>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import Auth from "../../auth";
import axios from "axios";

export default {
  name: "zoomSession",
  data() {
    return {
      defaultImg: require("../../assets/images/women.png"),
      info: {
        name: "",
        img: "",
        subject: "",
        curriculum: "",
        gender: "",
      },
      end_time_12_hrs: "",
      end_time_12_hrs_prefix: "",
      end_time_24_hrs: "",
      zoomUrl:
        window.location.origin +
        "/meeting/" +
        this.$router.currentRoute.params.reservationId,
      redirectUrl:
        Auth.type() == "Teacher" ? "/teacher/thankyou/" : "/student/thankyou/",
      sessionEnded: false,
      canJoin: false,
    };
  },
  methods: {
    launchMeeting() {
      this.$http
        .get(
          this.getApiUrl +
            "/sessions/launch/" +
            this.$router.currentRoute.params.reservationId,
          {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((res) => {
          this.end_time_12_hrs = res.data.data.end_time_12_hrs;
          this.end_time_12_hrs_prefix = res.data.data.end_time_12_hrs_prefix;
          this.info.name = res.data.data.info.name;
          this.info.img = res.data.data.info.img;
          this.info.gender = res.data.data.info.gender;
          this.info.subject = res.data.data.info.subject;
          this.info.curriculum = res.data.data.info.curriculum;
          this.end_time_12_hrs = res.data.data.end_time_12_hrs;
          this.end_time_12_hrs_prefix = res.data.data.end_time_12_hrs_prefix;
          this.canJoin = res.data.data.canJoin;
          if (res.data.status.error) {
            this.end_time_24_hrs = res.data.data.end_time_24_hrs;
            this.sessionEnded = true;
            this.checkMeetingStatus();
          }
          this.redirectIfNotAuthenticatd();
        });
    },
    redirectAfterSession() {
      // eslint-disable-next-line
      var path = this.$refs.iFrame.contentWindow.location.pathname;
      console.log(path);
      // eslint-disable-next-line
      var sessionId = this.$refs.iFrame.contentWindow.location.pathname.split(
        "/"
      )[3];
      if (path.indexOf("thank") >= 0) {
        this.$router.push({ path: this.redirectUrl + sessionId });
      }
    },
    checkMeetingStatus() {
      console.log("hereeeeeeeeee");
      // eslint-disable-next-line
      var hours = new Date().getHours();
      // eslint-disable-next-line
      var minutes = new Date().getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      console.log(hours + ":" + minutes);
      if (this.end_time_24_hrs <= hours + ":" + minutes) {
        this.sessionEnded = true;
      }
    },
    redirectIfNotAuthenticatd() {
      if (!this.canJoin) {
        //this.$router.push({ path: "/404" });
      }
    },
  },
  mounted() {
    this.launchMeeting();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.signUp {
  min-height: 50rem !important;
  background-image: url("../../assets/images/background-overlay.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed !important;
  position: relative;
  padding-top: $padding-top;
}
</style>
